<template>
  <div>
    <Header :headerTitle="$t('m.changeCarId.title')" :hasBackBtn="true"></Header>
    <section>
      <div class="mobile">
        <span v-show="isCarIdRequired">
          临&nbsp;
          <img src="../../assets/img/zhankai.png">
        </span>
        <span @click="provinceNameList" v-show="!isCarIdRequired">
          {{provinceName}}&nbsp;
          <img src="../../assets/img/zhankai.png">
        </span>
        <input type="text" disabled style="background-color:#fff;" v-show="isCarIdRequired">
        <input style="height:45px;width:80%;"
               type="text"
               :placeholder="$t('m.changeCarId.nullCarNumber')"
               v-model="licenseplate"
               maxlength="7"
               v-show="!isCarIdRequired"
               :onkeyup="validLicense()"
        >
        <!-- <p class="linpai">临牌&nbsp;
          <checkbox name="terms" v-model="isCarIdRequired"></checkbox>
        </p> -->
      </div>
      <b-button href="#" id="submitLogin" :disabled="licenseplate=='' && !isCarIdRequired">
        <span style="display: block;" @click="save()">{{$t('m.changeCarId.save')}}</span>
      </b-button>
    </section>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
  import {userEdit} from "../../api/user.js";

  export default {
    name: "changeCarId",
    data() {
      return {
        provinceName: "京", //车牌照
        isCarIdRequired: false, //牌照类型
        licenseplate: "", //车牌号
        tipDisplay: "none", //隐藏提示框
        message: "", //提示信息
        tipShow: "0", //是否提示
        tipType: "" //提示类型
      };
    },
    methods: {
      validLicense : function () {
        this.licenseplate = this.licenseplate.replace(/[^\w]/ig,'').toUpperCase();
      },
      //跳转选择车牌照页面
      provinceNameList: function () {
        this.$router.push("/ProvinceList");
      },
      //获取车牌照
      changeProvince: function (val) {
        this.provinceName = val;
      },
      //保存操作
      save: function () {
        var isTemporary = null;
        var carName =
            this.provinceName + this.licenseplate.replace(/[^\w]/ig,'').toUpperCase();
        if (this.isCarIdRequired == false) {
          if (this.licenseplate == null || this.licenseplate == "") {
            return;
          } else {
            isTemporary = 1;
            if (carName.length < 7 || carName.length > 8) {
              this.tipShow = "1" + Math.random() * 1000;
              this.message = this.$t('m.changeCarId.carFomat');
              this.tipType = "error";
              return;
            }
          }
        } else {
          isTemporary = 2;
          this.licenseplate = "";
          carName = "临";
        }
        userEdit({
          isTemporary: isTemporary,
          licenseplate: carName
        }).then(
            response => {
              if (response.data.status == 200) {
                this.tipShow = "1" + Math.random() * 1000;
                this.tipType = "success";
                this.message = this.$t('m.changeCarId.successMeassage');
                setTimeout(_ => {
                  window.history.back();
                }, 1000);
              } else {
                this.tipShow = "1" + Math.random() * 1000;
                this.tipType = "warning";
                this.message = response.data.message;
              }
            },
            err => {
              reject(err);
            }
        );
      }
    },
    mounted() {
      eventBus.$on("provinceName", this.changeProvince);
    },
    beforeRouteEnter(to, from, next) {
      if (from.name != "ProvinceList") {
        to.meta.otherBack = true;
      }
      next();
    },
    //页面缓存后每次都会调用
    activated() {
      this.isCarIdRequired = false;
      if (this.$route.meta.otherBack) {
        this.provinceName = "京";
        this.$route.meta.otherBack = false;
      }
    }
  };
</script>
<style scoped>
  section {
    margin: 15px;
  }

  section .mobile {
    margin-top: 20px;
    width: 100%;
    border-bottom: 2px solid #f5f5f5;
    border-top: 2px solid #f5f5f5;
  }

  section .mobile span {
    display: inline-block;
    width: 15%;

    border-right: 1.2px solid #b9b7b7;
  }

  section input {
    padding-left: 3%;
    width: 60%;
    border: 0px;
    font-size: 17px;
    height: 40px;
  }

  section p {
    width: 25%;
    display: inline-block;
    font-size: 14px;
  }

  #submitLogin {
    margin-top: 30px;
    color: #fff;
    border: 0;
    background-color: #0066B1;
    border-radius: 4px;
    line-height: 38px;
    width: 90%;
  }

  .tip {
    background: #2c3e50;
    position: absolute;
    margin: auto auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 1);
    opacity: 0.3;
    border-radius: 10px;
    width: 40%;
    padding-bottom: 40%;
    height: 0px;
  }

  .tip img {
    margin: 10px 0;
    width: 50%;
  }

  .tip p {
    color: #fff;
  }
</style>
